import {
  Form,
  Input,
  Switch,
  Checkbox,
  Radio,
  Divider,
  InputNumber,
} from "antd";
import ContentPadding from "../ContentConfig/ContentPadding";
import { ColorPickerFormItem } from "../Image/ImageConf";
import ContentID from "../Common/ContentID";
import ImageUpploadField from "../WechatTextImage/ImageUploadField";

export default ({ node }) => {
  return (
    <>
      <Form.Item label="Gutter" name="gutter">
        <InputNumber style={{ width: "100%" }} min={0} max={100} step={2} />
      </Form.Item>
      <ColorPickerFormItem
        label={"Row background color"}
        name="rowBackgroundColor"
        color={node.data.rowBackgroundColor}
      />

      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const hasBgColor = getFieldValue("rowBackgroundColor");
          if (hasBgColor) {
            return (
              <div
                style={{
                  display: "flex",
                  gap: 10,
                  justifyContent: "space-between",
                  marginBottom: 16,
                }}
              >
                <label>Apply background to</label>
                <Form.Item noStyle name={"applyBackgroundTo"}>
                  <Radio.Group
                    size="small"
                    defaultValue="row"
                    buttonStyle="solid"
                  >
                    <Radio.Button value="content">Content</Radio.Button>
                    <Radio.Button value="row">Row</Radio.Button>
                  </Radio.Group>
                </Form.Item>
              </div>
            );
          }
          return null;
        }}
      </Form.Item>

      <div
        style={{ display: "flex", gap: 10, justifyContent: "space-between" }}
      >
        <label>Row background image</label>
        <Form.Item
          noStyle
          valuePropName="checked"
          name={"enableRowBackgroundImage"}
        >
          <Switch />
        </Form.Item>
      </div>
      <div style={{ height: 11 }} />
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const enabled = getFieldValue("enableRowBackgroundImage");
          if (enabled) {
            return (
              <>
                <ImageUpploadField name="rowBackgroundImage" />
                <div style={{ height: 11 }} />
                <div
                  style={{
                    display: "flex",
                    gap: 10,
                    justifyContent: "space-between",
                  }}
                >
                  <label>Apply image to</label>
                  <Form.Item noStyle name={"applyImageTo"}>
                    <Radio.Group
                      size="small"
                      defaultValue="row"
                      buttonStyle="solid"
                    >
                      <Radio.Button value="content">Content</Radio.Button>
                      <Radio.Button value="row">Row</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 8,
                    justifyContent: "space-between",
                  }}
                >
                  <Form.Item
                    noStyle
                    valuePropName="checked"
                    name={"fitToBackground"}
                  >
                    <Switch size="small" />
                  </Form.Item>
                  <label style={{ marginLeft: 5 }}>Fit to background</label>
                  <div style={{ width: 30 }} />
                  <Form.Item
                    noStyle
                    shouldUpdate={(prev, curr) =>
                      prev.fitToBackground !== curr.fitToBackground
                    }
                  >
                    {({ getFieldValue, setFieldValue }) => {
                      const fitBg = getFieldValue("fitToBackground");
                      if (fitBg) {
                        setTimeout(() => {
                          setFieldValue("repeatBackgroundImage", false);
                          setFieldValue("centerBackgroundImage", false);
                        });
                      }
                      return (
                        <>
                          <Form.Item
                            noStyle
                            name="repeatBackgroundImage"
                            valuePropName="checked"
                          >
                            <Checkbox disabled={fitBg}>Repeat</Checkbox>
                          </Form.Item>
                          <Form.Item
                            noStyle
                            name="centerBackgroundImage"
                            valuePropName="checked"
                          >
                            <Checkbox disabled={fitBg}>Center</Checkbox>
                          </Form.Item>
                        </>
                      );
                    }}
                  </Form.Item>
                </div>
              </>
            );
          }
          return null;
        }}
      </Form.Item>
      <Divider />
      <div
        style={{ display: "flex", gap: 10, justifyContent: "space-between" }}
      >
        <label>Stack on mobile</label>
        <Form.Item noStyle name={"stackOnMobile"}>
          <Radio.Group size="small" buttonStyle="solid">
            <Radio.Button value="on">ON</Radio.Button>
            <Radio.Button value="off">OFF</Radio.Button>
          </Radio.Group>
        </Form.Item>
      </div>
      <Divider />
      <ContentID />
      <ContentPadding />
    </>
  );
};
